export default __webpack_public_path__ + "static/productsMain-663575e94ca5d892d6fad2b18b2a08ec.png";